import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Text } from 'components/core/Typography';

import './FacilityAddress.scss';

function getStreetProps(streetUrl, showSchema) {
	if (streetUrl) return { href: streetUrl, target: '_blank' };
	if (showSchema) return { itemProp: 'streetAddress' };
	return {};
}

export function FacilityAddress({
	className,
	address,
	streetUrl,
	showSchema = true,
}) {
	const StreetComponent = streetUrl ? Link : 'span';
	const streetProps = getStreetProps(streetUrl, showSchema);

	const schemaProps = showSchema
		? {
				itemProp: 'address',
				itemScope: true,
				itemType: 'http://schema.org/PostalAddress',
			}
		: {};

	return (
		<Text
			className={classnames('address', className)}
			{...schemaProps}
		>
			<StreetComponent {...streetProps}>
				<span className="street">{address.streetAddress1}</span>
				{address.streetAddress2 && (
					<span className="street2">{address.streetAddress2},</span>
				)}
			</StreetComponent>
			<span
				className="city"
				{...(showSchema && { itemProp: 'addressLocality' })}
			>
				{address.city},{' '}
			</span>
			<span
				className="state"
				{...(showSchema && { itemProp: 'addressRegion' })}
			>
				{address.state}{' '}
			</span>
			<span
				className="zip"
				{...(showSchema && { itemProp: 'postalCode' })}
			>
				{address.zip}
			</span>
		</Text>
	);
}

FacilityAddress.propTypes = {
	className: PropTypes.string,
	address: PropTypes.shape({
		streetAddress1: PropTypes.string.isRequired,
		streetAddress2: PropTypes.string,
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
		zip: PropTypes.string.isRequired,
	}).isRequired,
	streetUrl: PropTypes.string,
	showSchema: PropTypes.bool,
};

export default FacilityAddress;
